<template>
  <div id="app" :class="'lang_'+ lang + ' country_' + country" translate="no">

    <div class="preloader">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <Header/>

    <PageWrapper :id="id" :kapitel="kapitel"></PageWrapper>

    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/partials/Header";
import Footer from "@/components/partials/Footer";
import Settings from "@/settings/settings.json";
import PageWrapper from "@/views/pages/PageWrapper";

export default {

  name: 'App',
  components: {
    Header,
    Footer,
    PageWrapper
  },
  data() {
    return {
      texte: Array,
      lang: "",
      id: "010",
      kapitel: "01",
      country: "",
    }
  },
  created: function () {
    const modulename = Settings["Modulname"];
    const chapters = Settings["Chapters"];
    const lang = Settings["StandardLanguage"];
    let this_ = this;


    let environment = process.env.NODE_ENV;
    if(environment == "development"){
      this.$store.dispatch("enterModuleLocal", {module: modulename, lang: lang, chapters: chapters}).then(function () {
        this_.lang = this_.$store.getters.lang;
        this_.country = this_.$store.getters.country;
        if (this_.lang == 'ar' || this_.lang == 'AR') {
          this_.direction = 'rtl';
        } else {
          this_.direction = 'ltr';
        }

      });
      console.log(this)
    } else {
      this.$store.dispatch("enterModule", {module: modulename, lang: '', chapters: chapters}).then(function () {
        this_.lang = this_.$store.getters.lang;
        this_.country = this_.$store.getters.country;

        if (this_.lang == 'ar' || this_.lang == 'AR') {
          this_.direction = 'rtl';
        } else {
          this_.direction = 'ltr';
        }

      });
      console.log(this)
    }

    this.$store.watch(
        (state, getters) => getters.lang,
        (newValue, oldValue) => {
          this.lang = this.$store.getters.lang;
          if (this.lang == 'ar' || this.lang == 'AR') {
            this.direction = 'rtl';
          } else {
            this.direction = 'ltr';
          }
          console.log(`Updating from ${oldValue} to ${newValue}`);
        }
    ),
    this.$store.watch(
            (state, getters) => getters.country,
            (newValue, oldValue) => {
              this.country = this.$store.getters.country;
              console.log(`Updating from ${oldValue} to ${newValue}`);
            }
    )
  },
  watch: {
    '$route.params.id': function (id) {
      this.id = id;
    },
    '$route.params.kapitel': function (kapitel) {
      this.kapitel = kapitel;
    }
  },

};
</script>